import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import PhoneInput, { isValidPhoneNumber, parsePhoneNumber } from "react-phone-number-input";
import classNames from "classnames";
import { FormField } from "../../../components/Form";
import { InputWrapper } from "../../../components/Inputs/components/InputWrapper";
import { useTranslations } from "../../../providers/useTranslations";
import { CountrySelectWithIcon } from "./CountrySelectWithIcon";
import { useAvailableCountries, useCountryTranslations } from "./hooks";
import styles from "./InternationalTelephone.module.scss";
export const InternationalTelephone = ({ id, showLabel = true, label, fieldName = (name) => name, isRequired = true, isDisabled = false, disclaimer, placeholder, mode, editButtonLabel, onEditClick, isLocked, }) => {
    const { __ } = useTranslations();
    const availableCountriesInDropdown = useAvailableCountries();
    const countryLabels = useCountryTranslations(availableCountriesInDropdown);
    const [isEditable, setIsEditable] = useState(mode === "editable");
    const handlePhoneValue = (phone) => {
        if (phone) {
            if (phone.startsWith("+")) {
                return phone;
            }
            return `+${phone}`;
        }
        return "";
    };
    const validatePhoneNumber = (value) => {
        if (value) {
            if (!isValidPhoneNumber(handlePhoneValue(value))) {
                return __("internationalPhone.validation.invalid_format");
            }
            const phoneNumberCountry = parsePhoneNumber(value)?.country;
            if (phoneNumberCountry && !availableCountriesInDropdown.includes(phoneNumberCountry)) {
                return __("internationalPhone.validation.country_not_allowed");
            }
        }
        return true;
    };
    const handleOnEditClick = () => {
        setIsEditable(false);
        onEditClick();
    };
    return (_jsx("div", { className: styles.phoneContainer, children: _jsx(FormField, { id: id, name: id || fieldName("internationalPhone"), validation: {
                required: isRequired ? __("internationalPhone.validation.field_required") : false,
                validate: validatePhoneNumber,
            }, showCustomError: true, render: ({ field, fieldState: { error } }) => (_jsx(InputWrapper, { htmlFor: id, errorText: error?.message, helperText: disclaimer, isError: !!error, isOptional: !isRequired, labelId: `label-${id}`, label: (showLabel && label) || __("internationalPhone.label"), isHelperTextVisible: true, wrapperClassName: classNames(styles.wrapper, {
                    [styles.isLocked]: isEditable || isLocked,
                }), children: _jsx(PhoneInput, { ...field, international: true, "aria-labelledby": `label-${id}`, value: handlePhoneValue(field.value), labels: countryLabels, countries: availableCountriesInDropdown, disabled: isDisabled, placeholder: placeholder, countrySelectComponent: (props) => (_jsx(CountrySelectWithIcon, { ...props, mode: mode, editButtonLabel: editButtonLabel, handleOnEditClick: handleOnEditClick, isEditable: isEditable })), className: classNames(styles.phoneInputContainer, {
                        [styles.hasError]: error,
                        [styles.disabled]: isDisabled,
                        [styles.locked]: isEditable || isLocked,
                    }) }) })) }) }));
};
//# sourceMappingURL=InternationalTelephone.js.map